 <div class="content-block">

      <router-outlet></router-outlet>

    </div>
